
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'DealerCreditProfileTabs',

  props: ['formData', 'change'],

  setup(props) {
    const activeKey = ref('');
    const tablist = ref<any>([]);

    const change = (val) => {
      props.change(val);
    };

    const getTablist = () => {
      const tabs = props?.formData?.deliPlatformDisCreditAccountProxyList as any[];
      const list = tabs.map((i) => {
        return { name: i.bizName, id: i.id };
      });
      if (list && Array.isArray(list)) {
        activeKey.value = list[0].id;
        return list;
      }
      return [];
    };

    const stopWatch = watch(
      () => props.formData,
      (val) => {
        if (val?.deliPlatformDisCreditAccountProxyList) {
          tablist.value = getTablist();
          stopWatch();
        }
      },
      { deep: true }
    );

    return {
      tablist,
      activeKey,
      change
    };
  }
});
